import React from 'react'
import {
    Button, Table, Container,
    Row, Col, Label,
} from 'reactstrap'
import '../css/QuoteViewController.css'
import DateTextField from '../view/DateTextField'
import {
    getBacklogJobSearch,
} from '../model/request/backlog'
import { updateBacklogs } from '../model/request/backlog'
import { formatAsDollarValue, moneyText, dateOffsetText } from '../model/Formatting'
import { addUserTimeZone } from '../model/DateConverter'
import {JustDate} from '../model/JustDate';
import {
    InfoButton,
} from '../view/InfoButton'
import dateFormat from 'dateformat'

class BacklogSearchViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        this.state = {
            jobs: [],
        }
    }

    componentDidMount() {
        this.props.turnOnLoader()
        getBacklogJobSearch(this.props.search).then(
            (result) => {
                this.setState({
                    'jobs': result.data.jobs.map((job, index) => {
                        job.param1 = addUserTimeZone(job.param1)
                        return job
                    }),
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    renderDateInputRow(name, job, index) {

        return <td>
            <input type="checkbox" checked={job['is_checked' + name]}
                style={{
                    'display': 'inline-block',
                }}
                onChange={(e) => {
                    const jobs = this.state.jobs
                    jobs[index]['is_checked' + name] = !jobs[index]['is_checked' + name]

                    if (jobs[index]['is_checked' + name] &&
                        jobs[index]['date_picked' + name] === undefined) {
                        jobs[index]['date_picked' + name] = new JustDate()
                    }

                    this.setState({
                        'jobs': jobs,
                    })
                }} />
                <div style={{
                    'display': 'inline-block',
                    'width': 'min(600px, 100% - 22px)',
                    'marginLeft': '8px',
                }}>
                <DateTextField
                    style={{
                        'display': 'inline-block',
                    }}
                    value={job['date_picked' + name]}
                    showModal={this.props.showModal}
                    closeModal={this.props.closeModal}
                    onChange={(d) => {
                        const jobs = this.state.jobs
                        jobs[index]['date_picked' + name] = d
                        this.setState({
                            'jobs': jobs,
                        })
                    }}
                    />
            </div>
        </td>
    }


    // MARK: Render

    renderRows() {
        return this.state.jobs.map((job, index) =>
            <tr key={"row"+index}>
                <td><Label>
                    <a href={'/backlog/' + job.id} text={job.job_name}>{job.job_name}</a>
                </Label></td>
                <td><Label>
                    <a href={'/customerreport?filter=All&company=' + job.customer_name}>
                        {job.customer_name}
                    </a>
                </Label></td>
                <td><Label><span text={moneyText(job.total_price)}>{formatAsDollarValue(job.total_price)}</span></Label></td>
                <td><Label><span text={dateOffsetText(job.param1)}>{dateFormat(job.param1.toDateTime(), 'mmmm d, yyyy')}</span></Label></td>
                {this.renderDateInputRow('', job, index)}
                <td><Button
                    color={'success'}
                    onClick={(e) => {
                        this.props.turnOnLoader()

                        const backlogsToUpdate = job.backlogs_recieved || []
                        if (job.is_checked) {
                            backlogsToUpdate.push({
                                is_checked: job.is_checked,
                                quote_id: job.id,
                                type_id: '3d936366-25cf-4077-8abe-340c5c1882c5',
                                date_given: job.date_picked,
                            })
                            backlogsToUpdate.push({
                                is_checked: job.is_checked,
                                quote_id: job.id,
                                type_id: '0bafafb6-16ac-4603-9c13-84211d59e556',
                                date_given: job.date_picked,
                            })
                        }

                        updateBacklogs(backlogsToUpdate).then(
                            (result) => {
                                job.backlogs_recieved = result.data.backlogs.map((backlog, index) => {
                                    backlog.is_checked = false
                                    return backlog
                                })
                                this.props.turnOffLoader()
                            },
                            (error) => {
                                this.props.showError(error)
                                this.props.turnOffLoader()
                            }
                        )
                    }}>Save</Button></td>
            </tr>
        )
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <InfoButton
                            id={'backlogsearchdesc'}
                            message={
                                'All jobs that has customer ship date and is thermoformed but not recieved ' +
                                'thermoformed signs. Included jobs that have been shipped.'
                            } />
                    </Col>
                </Row>
                <Row>
                    <Col>
                    <Label style={{
                        'fontSize': '18px',
                        'fontWeight': '450',
                        'marginRight': '8px',
                    }}>Total Price:</Label>
                    <Label style={{
                        'fontSize': '18px',
                        'fontWeight': '400',
                    }}>{(() => {
                        const total = this.state.jobs.length > 0 ?
                            this.state.jobs.map((x) => x.total_price)
                                .reduce((l, r) => l+r) : 0
                        return <span text={moneyText(total)}>{formatAsDollarValue(total)}</span>
                    })()}</Label>
                    </Col>
                </Row>
                <Row><Col><div style={{'overflowX': 'auto'}}><Table>
                    <thead>
                        <tr>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}>Job</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}>Customer</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}>Total Cost</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}>Promise Date</th>
                            <th
                                className="text-center label-weight"
                                style={{'minWidth': '200px'}}
                                >Ready For Production and Recieved Thermoformed</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderRows()}
                    </tbody>
                </Table></div></Col></Row>
            </Container>
        )
    }
}

export default BacklogSearchViewController

